export default "/images/framework/Success.de44e68d.svg?de44e68d";